import React, {Component} from 'react';
import App from "../../App";
import {withRouter} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { getPaginatedList, getList } from "../../services/baseServices";
import { getFormattedDate, replaceUnderscoreWithSpaceOfStr } from '../../helper/utils';
import Pagination from "react-js-pagination";
import ExportCSVAsync from "../common/ExportCSVAsync";
import moment from "moment";
import {Button} from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Loader from 'react-loader';

const headers = [
	{ label: "Order Id", key: "order_id" },
	{ label: "Distributor Id", key: "dh_id" },
	{ label: "Rider Id", key: "rider_id" },
	{ label: "SR Id", key: "route_id" },
	{ label: "Partner Id", key: "partner_id" },
	{ label: "Shipping Type", key: "shipping_type" },
	{ label: "Payment Type", key: "payment_type" },
	{ label: "Amount", key: "amount" },
	{ label: "Order Date", key: "order_date" },
	{ label: "Completed Date", key: "completed_at" },
	{ label: "SR Collected At", key: "sr_collected_at" },
	{ label: "Rider Collected At", key: "rider_collected_at" },
  { label: "Reconciliation At", key: "reconciliation_at" },
	{ label: "Deposited At", key: "deposited_at" },
	{ label: "Received At", key: "received_at" },
];

const loadData = (item) => {
	return {
		order_id: item.order_id,
		fc_id: item.fc_id,
    rider_id: item.rider_id,
    route_id: item.route_id,
    partner_id: item.partner_id,
    shipping_type: item.shipping_type,
    payment_type: item.payment_type,
    amount: item.amount,
		order_date: getFormattedDate(item.order_date, "DD-MM-YYYY"),
		completed_at: getFormattedDate(item.completed_at, "DD-MM-YYYY"),
		sr_collected_at: getFormattedDate(item.sr_collected_at, "DD-MM-YYYY"),
		rider_collected_at: getFormattedDate(item.rider_collected_at, "DD-MM-YYYY"),
		reconciliation_at: getFormattedDate(item.reconciliation_at, "DD-MM-YYYY"),
		deposited_at: getFormattedDate(item.deposited_at, "DD-MM-YYYY"),
		received_at: getFormattedDate(item.received_at, "DD-MM-YYYY"),
	};
};

var startDate = moment().subtract(29, 'days');
var today = moment();

class List extends Component {
  constructor() {
    super();
    this.state = {
      list: [],
      distributors: [],
      isLoading: true,
      activePage: 1,
      per_page: 15,
      page: 1,
      temp_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD"), distributor_id: ''},
      query_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD"), distributor_id: ''},
      start_date_time: startDate,
      end_date_time: today,
  };
  }

  getQueryParams = () => {
      let params = {per_page: this.state.per_page, page: this.state.page};
      return params;
  }

  getPaginatedOPCRList = (params) => {
      this.setState({...this.state, isLoading: true});
      getPaginatedList("payment_reports/report", params)
          .then(res => {
              this.setState({
                  list: res.data,
                  isLoading: false,
                  per_page: res.headers['x-per-page'],
                  total_data: res.headers['x-total'],
              }, () => {
              });
          })
          .catch(errMsg => {
              this.setState({...this.state, isLoading: false});
              console.log('Error Message: ', errMsg)
          })
  }

  componentDidMount() {
      this.getPaginatedOPCRList(this.getQueryParams());
      getList("distributors")
          .then((res) => {
            this.setState({ distributors: res });
          })
          .catch((errMsg) => {});
  }

  handlePageChange = (pageNumber) => {
      this.setState({page: pageNumber, activePage: pageNumber}, () => {
          this.getPaginatedOPCRList(this.getQueryParams());
      });
  }

  handleOnSearch = (e) => {
    e.preventDefault();
    const tempParam = this.state.temp_params;
    console.log(tempParam)
    this.setState({...this.state, page: 1, query_params: tempParam}, () => {
        this.getPaginatedOPCRList(this.state.temp_params);
    });
}

handleOnApply = (e, picker) => {
  this.setState({
      start_date_time: getFormattedDate(picker.startDate, ''),
      end_date_time: getFormattedDate(picker.endDate, '')
  })
  this.setState({
      temp_params: {
          ...this.state.temp_params,
          start_date_time: getFormattedDate(picker.startDate, "YYYY-MM-DD"),
          end_date_time: getFormattedDate(picker.endDate, "YYYY-MM-DD")
      }
  })
}

handleOnFieldChange = (e) => {
  const queryData = {...this.state.temp_params};
  queryData[e.target.name] = e.target.value;
  this.setState({temp_params: queryData});
}
  
  render() {
    return (
      <App layout="">
        <div className="main-content">
          <div className="page-header">
           <h2 className="page-title">Order Payment Collection Report</h2>
           <div className="ml-auto d-flex">
              <ExportCSVAsync
                  fileName={
                      "Order-Payment-Collection-Report" + getFormattedDate(new Date(), "DD-MM-YYYY") + ".csv"
                  }
                  Url="payment_reports/report?skip_pagination=true"
                  headers={headers}
                  params={this.state.query_params}
                  loadData={loadData}
                  title="Order Payment Collection Report"
              />
          </div>
          </div>

          <form className="form-inline mb-3">
              <div className="form-group mr-3">
                  <label htmlFor="status" className="sr-only">
                      Date Range
                  </label>
                  <DateRangePicker
                      initialSettings={{
                          startDate: this.state.start_date_time,
                          endDate: this.state.end_date_time,
                          maxSpan: {"months": 3},
                          showDropdowns: true,
                          locale: {format: "DD/MM/YYYY"},
                          autoApply: true,
                      }}
                      onApply={(e, picker) => this.handleOnApply(e, picker)}
                  >

                      <input type="text"
                              value={this.state.start_date_time && this.state.end_date_time ? `${getFormattedDate(this.state.start_date_time, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time, "DD/MM/YYYY")}` : ''}
                              style={{textAlign: 'left', minWidth: '150px'}}
                              placeholder={"Select date range"}
                              className="form-control form-control-sm"/>
                  </DateRangePicker>
              </div>
              <div className="form-group mr-3">
                  <label htmlFor="supplier_id" className="sr-only">
                      Supplier
                  </label>
                  <select
                      id="distributor_id"
                      name="distributor_id"
                      className="form-control form-control-sm"
                      onChange={(e) => {
                          this.handleOnFieldChange(e);
                      }}
                  >
                  <option value="">--Select Distributor--</option>
                  {this.state.distributors?.length > 0
                      ? this.state.distributors.map((item, i) => {
                          return (
                          <option key={i} value={item.id} selected={this.state.temp_params.distributor_id === item.id}>
                              {item.name}
                          </option>
                          );
                      })
                      : ""}
                  </select>
              </div>
              <Button
                  size="sm"
                  type={`submit`}
                  onClick={this.handleOnSearch}
                  variant="primary"
              >
                  Filter
              </Button>
          </form>
          <Loader loaded={!this.state.isLoading}>
          <div className="card-block">
            <div className="block-body table-responsive">

              <table className="order-table table table-striped">
                <thead>
                <tr>
                    <th style={{width: "20px"}}>#</th>
                    <th>Order ID</th>
                    <th>FC ID</th>
                    <th>Rider ID</th>
                    <th>SR ID</th>
                    <th>Partner ID</th>
                    <th>Shipping Type</th>
                    <th>Payment Type</th>
                    <th>Amount</th>
                    <th>Order Date</th>
                    <th>Completed at</th>
                    <th>SR Collected at</th>
                    <th>Rider Collected at</th>
                    <th>Reconciliation at</th>
                    <th>Deposited at</th>
                    <th>Received at</th>
                </tr>
                </thead>
                <tbody>
                {this.state.list?.length > 0 ? this.state.list.map((item, index) => {
                  return (
                      <tr key={index}>
                        <td>
                          {(this.state.page - 1) * this.state.per_page +
                          index +
                          1}
                        </td>
                        <td>
                          <div className="order-item">
                            {item.order_id || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {item.fc_id || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                            {item.rider_id || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {item.route_id || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {item.partner_id || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {replaceUnderscoreWithSpaceOfStr(item.shipping_type) || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {replaceUnderscoreWithSpaceOfStr(item.payment_type) || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {item.amount || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.order_date, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.completed_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.sr_collected_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.rider_collected_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.reconciliation_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.deposited_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                        <td>
                          <div className="order-item">
                          {getFormattedDate(item.received_at, 'DD/MM/YYYY HH:mm:ss') || '_'}
                          </div>
                        </td>
                      </tr>
                  );
                }) : (
                  <tr>
                      <td colSpan={15} className="text-center">
                          {" "}
                          <h5>No Order Found</h5>
                      </td>
                  </tr>
              )}
                </tbody>
              </table>
            </div>
            <div className="mt-3">
                <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_data}
                    pageRangeDisplayed={10}
                    onChange={this.handlePageChange.bind(this)}
                />
            </div>
          </div>
          </Loader>
        </div>
      </App>
    );
  }
}

export default withRouter(List);
